<template>
  <section>
    <h4 class="fs-20 font-medium mb-4">
      Trip length
    </h4>

    <checkbox v-model="options.tripLengthOptions.min0" @change="$emit('filter-changed')">
      Less than 5 days
    </checkbox>
    <checkbox v-model="options.tripLengthOptions.min5" @change="$emit('filter-changed')">
      5 to 8 days
    </checkbox>
    <checkbox v-model="options.tripLengthOptions.min8" @change="$emit('filter-changed')">
      More than 8 days
    </checkbox>
  </section>
</template>

<script>
import Checkbox from '../../core/Checkbox'

export default {
  components: {
    Checkbox
  },
  inject: ['options']
}
</script>